module.exports = __webpack_public_path__ + "static/media/play-icon-restaurant.0717d945.svg";